/**
 * Brand colours for the values these screens repeat constantly.
 *
 * All drawn from the palette in `tailwind.config.js` — primary (green),
 * secondary (coral), creams, action and neutral. Nothing invented: a one-off
 * hex here is a colour nobody else can reuse and that no design change reaches.
 *
 * The rule behind the choices: colour carries meaning or it is noise. A
 * vertical is a category, so the three get distinct hues. A status is a
 * position in a funnel, so it runs cool to warm. Anything needing attention
 * borrows the alert and danger colours already used elsewhere in the admin.
 */
export const CHIP =
  'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-gilroy-medium';

/** Three categories, three hues. Not a ranking — no colour is "better". */
export const VERTICAL_STYLE: Record<string, string> = {
  furnishing: 'bg-secondary-50 text-secondary-700',
  acquisition: 'bg-primary-50 text-primary-700',
  reservation: 'bg-blue text-neutral-500'
};

/**
 * Cool while the lead is live, green when it lands, warm when it stalls.
 * `duplicate` is deliberately flat — it is bookkeeping, not an outcome.
 */
export const STATUS_STYLE: Record<string, string> = {
  new: 'bg-blue text-neutral-500',
  pending: 'bg-creams-500 text-creams-900',
  resolved: 'bg-primary-100 text-primary-800',
  reopened: 'bg-secondary-100 text-secondary-800',
  not_reachable: 'bg-neutral-50 text-neutral-400',
  duplicate: 'bg-neutral-50 text-neutral-300'
};

/** Seniority in the reporting tree, darkest at the top. */
export const ROLE_STYLE: Record<string, string> = {
  manager: 'bg-primary-500 text-neutral-0',
  lead: 'bg-primary-200 text-primary-900',
  senior: 'bg-primary-50 text-primary-700',
  agent: 'bg-creams-400 text-creams-900'
};

export const styleFor = (map: Record<string, string>, key?: string): string =>
  (key && map[key]) || 'bg-neutral-50 text-neutral-400';
